import React, { useState, useEffect } from 'react';

interface FloatingActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

/**
 * FloatingActionButton: Fixed button that appears after scrolling down
 * Typically used for "back to top" or quick actions
 * Fades in/out with smooth animation
 */
const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ 
  children, 
  onClick, 
  className = "" 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      // Show button after scrolling 300px down
      setIsVisible(scrolled > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <button
      onClick={onClick}
      className={`
        fixed bottom-8 right-8 z-40
        w-14 h-14 rounded-full
        bg-primary-600 hover:bg-primary-700
        text-white shadow-lg hover:shadow-xl
        transform transition-all duration-300 ease-out
        ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'}
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default FloatingActionButton; 